<template>
  <div>
    <div class="row">
      <div class="col-lg-12 p-5 b-blue">
        <div class="container">
          <General :user="user.profile" :contacted="user.contacted" :course="user.course" :total="user.totCurse"/>
        </div>
      </div>
    </div> 
  </div>
</template>
<style scoped lang="scss">
    @media only screen and (max-width: 480px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 544px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 768px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 960px) {
      #right, #left {
        text-align: center !important;
      }
    }

    @media only screen and (max-device-width: 480px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (device-width: 768px) {
      #right, #left {
        text-align: center !important;
      }
    }

</style>
<script>
  import General from './elements/General' 

  export default {
    components: {
      'General': General, 
    },
    props: {
      controls: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        modal: false,
        modalFilePreview: false,
        filePreview: null,
        fileDownload: null,
        motivos: [{
          text: 'Selecciona una opción',
          value: null
        }, 'Conseguí empleo en Kllaar.com', 'Conseguí empleo en otro sitio', 'Otro motivo'],
        form: {
          motivo: null
        },
        downloading: false,
        user: {},
        curse:''
      }
    },
    mounted() {

    },
    methods: {
      openFile(file) {
        this.fileDownload = file
        let ext = file.substr(file.lastIndexOf('.') + 1);
        if (ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'gif') {
          this.filePreview = file
        } else {
          this.filePreview = null
        }

        this.modalFilePreview = true

      },
      loadProfile(id) {
        this.downloading = true
        this.api.get('candidate/profile2?user_id=' + id + '&curse_id='+ this.curse ).then(({data}) => { //Obtener toda la información de usuario y enviarla a los componentes
          this.user = data
          this.downloading = false
          this.registrarVisita();
        }).catch(err => {
        })
      },
      registrarVisita() {
        this.api.get("candidate/view-cv?student_id="+user.student_info.id).then(
          response=>{
            console.log(response)
          }
        )
      }
    },
    created() {
      let id = this.$route.params.id
      this.curse = this.$route.query.curse
      this.loadProfile(id)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/curses/Students.vue